import type { FaireProductEntity } from "../../entity_types/product";

export const p_u5ua8vpxxh: FaireProductEntity = {
  token: "p_u5ua8vpxxh",
  type: "product",
  name: "Salon only: Honey Wash Backbar (not for resale)",
  brandToken: "b_1ov944qwit",
  brandName: "Oyin Handmade",
  imageUrl:
    "https://cdn.faire.com/fastly/b4d85cc5737eeb3206b18cfa40c9ee069829138266de338739e6fd859e244587.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd7ecf06786f29c6ffd0a9e26927c43f98923403e4e653fcd6cb51d8e3dea75f.jpeg",
  ],
  priceDollars: 60,
  description:
    "*These backbar sizes are not for resale, and are made available for salon customers only. Please message us for preapproval if you provide haircare services at your location. Thank you!*  \n      \nThis luxurious sulfate-free natural shampoo gets your hair cleaner than clean and is kind to kinks, coils and curls. Bathe your hair in our natural formula that helps coat, cleanse and protect each strand of your hair with quinoa protein, organic aloe vera juice, and pure honey.",
  tags: [],
  msrpDollars: 120,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:38.406Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
